import { useState } from "react"
import { useApi } from "utils"
import { LiquidityYearlyKey, LiquidityYearlySuccessFetch } from "../../types/liquidityYearTable"


export const yearlyApis = [
  {
    category: "LIQUIDITY RATIOS",
    code_budget: "CR",
    key_description: "Current Ratio",
    url: "/analytic/current_ratio/yearly_summary"
  },
  {
    category: "LIQUIDITY RATIOS",
    code_budget: "QCR",
    key_description: "Quick Current Ratio",
    url: "/analytic/quick_current_ratio/yearly_summary"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "DTER",
    key_description: "Debt To Equity Ratio",
    url: "/analytic/debt_to_equity_ratio/yearly_summary"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "FL",
    key_description: "Financial Leverage",
    url: "/analytic/finacial_leverage_ratio/yearly_summary"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "TL",
    key_description: "Total Leverage",
    url: "/analytic/total_leverage_ratio/yearly_summary"
  },
  {
    category: "PROFITABILITY",
    code_budget: "GMP",
    key_description: "Gross Margin Percentage",
    url: "/analytic/gross_margin_percentage_ratio/yearly_summary"
  },
  {
    category: "PROFITABILITY",
    code_budget: "NOMP",
    key_description: "Net Operating Margin Percentage",
    url: "/analytic/net_operating_margin_percentage_ratio/yearly_summary"
  },
  {
    category: "PROFITABILITY",
    code_budget: "NPM",
    key_description: "Net Profit Margin",
    url: "/analytic/net_profit_margin_ratio/yearly_summary"
  },
  {
    category: "EFFICIENCY RATIOS",
    code_budget: "ROA",
    key_description: "Return On Assets",
    url: "/analytic/return_of_asset_ratio/yearly_summary"
  },
  {
    category: "EFFICIENCY RATIOS",
    code_budget: "ITR",
    key_description: "Inventory Turnover Ratio",
    url: "/analytic/inventory_turnover_ratio/yearly_summary"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "ROE",
    key_description: "Return On Equity",
    url: "/analytic/return_on_equity_ratio/yearly_summary"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "OP",
    key_description: "Operating Ratio",
    url: "/analytic/operating_ratio/yearly_summary"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "OL",
    key_description: "Operating Leverage",
    url: "/analytic/operating_leverage_ratio/yearly_summary"
  }
  
]

export function useLiquidityRatioYearly(
  year?: number,
  location_id?: string | ""
) {
  const api = useApi()

  const [data, setData] = useState<LiquidityYearlyKey[]>([])
  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    if (!year) return
  
    setLoading(true)
  
    try {
      const params: any = { year }
  
      if (location_id && location_id !== "") {
        params.location_id = location_id
      }
  
      const responses = await Promise.all(
        yearlyApis.map(async (item) => {
          try {
            const res = await api.get(item.url, { params })
  
            const response: LiquidityYearlySuccessFetch = res.data
  
            const payload = response.payload?.[0]
  
            return {
              ...payload,
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget
            }
          } catch {
            return {
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget,
              data: []
            }
          }
        })
      )
  
      setData(responses)
    } catch {
      setData([])
    } finally {
      setLoading(false)
    }
  }

  return {
    yearlyData: data,
    loading,
    refetchYearly: fetchData
  }
}